import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import MainContainer from './components/MainContainer';
import { AuthState } from './views/auth/types';
import { useAppDispatch, useAppSelector } from './hooks';
import { getUserProfile, initializeLogin } from './views/auth/reducer';
import Workflow from './views/workflow/pages/workflow';
import Loading from './components/Loading';
import { WavelightWorkflowState } from './views/workflow/types';

function App() {
  const dispatch = useAppDispatch();
  const { session, isProfileLoading }: AuthState = useAppSelector(
    (state) => state.auth,
  );
  const { currentStepIndex }: WavelightWorkflowState = useAppSelector(
    (state) => state.workflow,
  );

  // Recover Tokens from LocalStorage
  useEffect(() => {
    dispatch(initializeLogin());
  }, [dispatch]);

  useEffect(() => {
    if (session.logged) {
      dispatch(getUserProfile());
    }
  }, [dispatch, session.logged]);

  // Show loading while verifying the token and not in the last step (because in the last step this profile verification is done again)
  if (session.recoveringSession || (isProfileLoading && currentStepIndex !== 2))
    return <Loading message="Inicializando" />;

  return (
    <MainContainer>
      <Routes>
        {/* App */}
        <Route path="/" element={<Workflow />} />
        <Route path="/send" element={<Workflow />} />
      </Routes>
    </MainContainer>
  );
}

export default App;
